<app-side-top-bar [navigationItems]="navigationItems">
  <main class="create-modify-expense-sts">
    <section class="create-modify-expense-sts-section">
      <header class="header">
        <h2>{{ isEditMode ? "Modifica Spesa STS" : "Nuova Spesa STS" }}</h2>
      </header>

      @if (isLoading) {
        <div class="loading-container">
          <app-loader [size]="'big'"></app-loader>
        </div>
      }

      @if (!isLoading && invoiceForm) {
        <div class="form-content">
          <form [formGroup]="invoiceForm" class="invoice-form">
            <section class="dati-documento">
              <h3>Dati Documento</h3>
              <div class="document-grid">
                <div class="document-row">
                  <mat-form-field>
                    <mat-label>Tipo</mat-label>
                    <input matInput formControlName="tipo" readonly />
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Cliente</mat-label>
                    <input
                      matInput
                      formControlName="cliente"
                      [matAutocomplete]="clientAuto"
                      (input)="filterClients($event)"
                      (focus)="showAllClients()"
                      (blur)="onClientBlur()"
                    />
                    <mat-autocomplete #clientAuto="matAutocomplete">
                      @for (client of filteredPrivateClients; track client.id) {
                        <mat-option
                          [value]="
                            client.client_first_name +
                            ' ' +
                            client.client_last_name
                          "
                          (onSelectionChange)="selectClient(client, $event)"
                        >
                          {{ client.client_first_name }}
                          {{ client.client_last_name }}
                        </mat-option>
                      }
                    </mat-autocomplete>
                  </mat-form-field>
                  <div class="progressivo-container">
                    <mat-form-field>
                      <mat-label>Numero</mat-label>
                      <input
                        matInput
                        formControlName="progressivo_numero"
                        minlength="3"
                        maxlength="3"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="document-row">
                  <mat-form-field>
                    <mat-label>Data</mat-label>
                    <input
                      matInput
                      [matDatepicker]="picker"
                      formControlName="data"
                      appDateInput
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Descrizione</mat-label>
                    <input matInput formControlName="riferimento" />
                  </mat-form-field>
                  <mat-slide-toggle formControlName="flag_opposizione">
                    Opposizione invio CF
                  </mat-slide-toggle>
                  <div class="empty-field"></div>
                </div>
              </div>
            </section>

            <section class="linee-documento">
              <h3>Linee Documento</h3>
              <div class="table-container">
                <table>
                  <thead>
                    <tr>
                      @for (col of displayedColumns; track col) {
                        <th [class]="col">{{ col }}</th>
                      }
                    </tr>
                  </thead>
                  <tbody>
                    @for (row of regularLines; track row.trackId) {
                      <tr [formGroup]="getLineGroup(row.lineIndex)">
                        <td>
                          <input
                            matInput
                            formControlName="descrizione"
                            maxlength="1000"
                            required
                            (focus)="markLineDescrizioneTouched(row.lineIndex)"
                          />
                        </td>
                        <td>
                          <input
                            matInput
                            formControlName="quantita"
                            type="number"
                          />
                        </td>
                        <td>
                          <input
                            matInput
                            formControlName="prezzo"
                            type="number"
                            min="0"
                            step="0.01"
                            placeholder="€"
                          />
                        </td>
                        <td>
                          <mat-select formControlName="iva_option">
                            @for (option of ivaOptions; track option) {
                              <mat-option [value]="option.split(':')[0]">
                                {{ option }}
                              </mat-option>
                            }
                          </mat-select>
                        </td>
                        <td>
                          <input matInput formControlName="totale" readonly />
                        </td>
                        <td>
                          <button
                            mat-icon-button
                            type="button"
                            (click)="removeDocumentLineByTrackId(row.trackId)"
                            [disabled]="regularLines.length === 1"
                          >
                            <mat-icon>delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
                <button
                  mat-raised-button
                  color="secondary"
                  type="button"
                  (click)="addDocumentLine()"
                >
                  Nuova Linea
                </button>
                @if (bolloLineGroup; as bolloLine) {
                  <table class="bollo-line-table">
                    <tbody>
                      <tr [formGroup]="bolloLine">
                        <td class="descrizione">
                          <input
                            matInput
                            formControlName="descrizione"
                            maxlength="1000"
                            required
                            (focus)="markBolloDescrizioneTouched()"
                          />
                        </td>
                        <td class="quantita">
                          <input
                            matInput
                            formControlName="quantita"
                            type="number"
                          />
                        </td>
                        <td class="importo">
                          <input
                            matInput
                            formControlName="prezzo"
                            type="number"
                            readonly
                          />
                        </td>
                        <td class="iva">
                          <mat-select formControlName="iva_option">
                            @for (option of ivaOptions; track option) {
                              <mat-option [value]="option.split(':')[0]">
                                {{ option }}
                              </mat-option>
                            }
                          </mat-select>
                        </td>
                        <td class="totale">
                          <input matInput formControlName="totale" readonly />
                        </td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>
                }
              </div>
            </section>

            <section class="cassa-previdenza">
              <h4>Cassa Previdenza</h4>
              <mat-form-field>
                <mat-label>Tipologia Cassa</mat-label>
                <mat-select formControlName="tipologia_cassa">
                  @for (option of tipologiaCassaOptions; track option.code) {
                    <mat-option [value]="option.code">
                      {{ option.description }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>% Cassa</mat-label>
                <input matInput formControlName="percentuale_cassa" />
              </mat-form-field>
              <mat-form-field>
                <mat-label>IVA</mat-label>
                <mat-select formControlName="cassa_previdenza_codice_iva">
                  @for (option of ivaOptions; track option) {
                    <mat-option [value]="option.split(':')[0]">
                      {{ option }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </section>

            <section class="dati-pagamento">
              <h4>Dati Pagamento</h4>
              <mat-form-field>
                <mat-label>Scadenza</mat-label>
                <mat-select formControlName="scadenza">
                  <mat-option value="Vista fattura">Vista fattura</mat-option>
                  <mat-option value="3 giorni">a 3 giorni</mat-option>
                  <mat-option value="7 giorni">a 7 giorni</mat-option>
                  <mat-option value="14 giorni">a 14 giorni</mat-option>
                  <mat-option value="30 giorni">a 30 giorni</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Pagamento</mat-label>
                <mat-select formControlName="pagamento">
                  <mat-option value="Carta di Pagamento"
                    >Carta di Pagamento</mat-option
                  >
                  <mat-option value="Bonifico">Bonifico</mat-option>
                  <mat-option value="Contanti">Contanti</mat-option>
                </mat-select>
              </mat-form-field>
              @if (isBonifico) {
                <mat-form-field>
                  <mat-label>Banca</mat-label>
                  <mat-select formControlName="doctor_bank_name">
                    @for (bank of bankNameOptions; track bank) {
                      <mat-option [value]="bank">{{ bank }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                <mat-form-field>
                  <mat-label>IBAN</mat-label>
                  <mat-select formControlName="doctor_bank_iban">
                    @for (iban of bankIbanOptions; track iban) {
                      <mat-option [value]="iban">{{ iban }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
            </section>

            <div class="form-buttons">
              <button
                class="button-white"
                mat-stroked-button
                type="button"
                (click)="onCancel()"
              >
                Annulla
              </button>
              <button
                class="button-white"
                mat-stroked-button
                color="primary"
                type="button"
                (click)="onContinue()"
              >
                Continua
              </button>
            </div>
          </form>
        </div>
      }
    </section>
  </main>
</app-side-top-bar>
